import axios from "./axios";
import qs from "qs";

const baseUrl = "/biz/oss/";

export default {
  /** 分页查询，参数：currentPage、pageSize、bizModule、operateUserId（超管） */
  page(params) {
    return axios.get(baseUrl + "page", { params });
  },
  /** multipart：file、bizModule */
  upload(formData) {
    return axios.post(baseUrl + "upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  /** multipart：多个同名 files、bizModule；成功列表 ldata，失败 mdata.batchFailures */
  uploadBatch(formData) {
    return axios.post(baseUrl + "uploadBatch", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  delete(id) {
    return axios.post(baseUrl + "delete", qs.stringify({ id }));
  },
};
